import { FontSize } from '@/app/app/interfaces/api/user-settings';

// Root (html) font size per font size setting
export const FONT_SIZES: Record<FontSize, string> = {
  small: '0.75rem',
  normal: '1rem',
  large: '1.25rem',
};
